import React from 'react';


const About = () => {
  return (
    <div className="About">
      <div className='abt-info'>
          <section className="why-us">
            <h3>Why Choose Us?</h3>
            <div className='txt-contain'>
              <p>
                Here at Chambers Electrical and Communications, we take pride in providing dependable and quality service to our customers. 
                Our dedication to customer service and ensuring that our work meets industry standards and exceeds your expectations is what sets us apart from other electrical contractors in our area. 
                We invite you to give us a call or schedule an appointment to experience the difference.
              </p>
            </div>
          </section>
          <section className="our-commitment">
            <div className='ctn-1'>
              <h3 className='oc-h3'>Our Commitment</h3>
              <p className='oc-p'>
                <span className='bolder'>We are committed to delivering exceptional value to our customers on a daily basis.</span>
                <br/>
                <br/>
                That's why we strictly adhere to our number one rule of the business: <span className='highlight'>getting the job done right the first time!</span>
                <br/>
                <br/> 
                By consistently delivering quality electrical work, we have earned a high rate of customer satisfaction and loyalty.
                <br/>
                <br/>
                Building a reputation as a reliable and high-quality electrical contractor requires time and perseverance.
              </p>
            </div>
            <div className='img-div'></div>
          </section>
          <section className="owners-section">
            <div className='ctn-2'>
              <div className='os-header'>
                  <h3 className='os-h3'>MICHAEL CHAMBERS, OWNER/OPERATOR</h3>
                  <div className='img-frame'></div>
                  <p className='os-opening'>
                    With a deep-rooted connection to the community, Michael has been a lifelong resident of RVA. 
                    His passion for the electrical industry sparked at a young age, when he embarked on his career journey as an apprentice at just 17 years old.
                  </p>
              </div>
              <p> 
                Recognizing the importance of continuous learning, Michael furthered his knowledge and skills through formal education, ultimately earning his certification as an electrician.
                Driven by ambition and dedication, Michael's hard work paid off when he achieved the esteemed status of Journeyman in 2013.
                <br/>
                <br/> 
                This accomplishment marked a significant turning point in his career, propelling him towards greater success and advancement. 
                Continuously striving for excellence, Michael's unwavering commitment to his craft led him to become a Master Electrician, solidifying his expertise and reputation in the field.
                <br/>
                <br/>
                Drawing from his extensive experience and expertise, Michael took a leap of faith in 2021 and founded Chambers Electrical and Communications. 
                This milestone represents the years of hard work, and commitment to providing top-notch electrical services to the community of RVA and surrounding areas.
              </p>
            </div>
          </section>
      </div>
    </div>
  );
};

export default About;